module.exports = __webpack_public_path__ + "img/2.bda0d562.png";